export default "__VITE_ASSET__4qqbUKS5__"